import { render, staticRenderFns } from "./GamificationCampaigns.vue?vue&type=template&id=42bf218c&scoped=true&"
import script from "./GamificationCampaigns.vue?vue&type=script&lang=js&"
export * from "./GamificationCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./GamificationCampaigns.vue?vue&type=style&index=0&id=42bf218c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bf218c",
  null
  
)

export default component.exports